export default {
  twitter: 'https://twitter.com/madebybowtie',
  github: 'https://github.com/madebybowtie',
  instagram: 'https://instagram.com/madebybowtie',
  dribbble: 'https://dribbble.com/gellermark',
  mail: 'hello@bowtie.studio',
  messenger: 'https://m.me/madebybowtie',
  adress: 'https://goo.gl/maps/9QpJKLMVcow',
  baseUrl: 'https://bowtie.studio',
}



// WEBPACK FOOTER //
// ./src/config.js